import React from 'react';
import AdminLayout from '../../../Components/CommonComponents/Layout/adminLayout';
import CouponCodesContainer from '../../../Containers/AdminContainer/CouponCodes';
const CouponCodesScreen = () => {
  return <CouponCodesContainer />;
};

export default CouponCodesScreen;
